"use strict";
//
// Object.fromEntries
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeSafeObjectKeys = exports.typeSafeObjectEntries = exports.typeSafeObjectFromEntries = void 0;
const typeSafeObjectFromEntries = (entries) => Object.fromEntries(entries);
exports.typeSafeObjectFromEntries = typeSafeObjectFromEntries;
//
// Object.entries
// (add const param for less broader types (ie. string -> "apple") -> const T extends Record<PropertyKey, unknown>)
//
const typeSafeObjectEntries = (obj) => Object.entries(obj);
exports.typeSafeObjectEntries = typeSafeObjectEntries;
const typeSafeObjectKeys = (obj) => Object.keys(obj);
exports.typeSafeObjectKeys = typeSafeObjectKeys;
//# sourceMappingURL=objects.js.map